import "../trendStyles.scss";
import { Autocomplete, Badge, Box, Button, IconButton, TextField } from '@mui/material';
import Grid from "@mui/material/Grid2";
import FmdBadIcon from '@mui/icons-material/FmdBad';
import { useSelector } from "src/stateManagement/redux";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Filter, FilterDrawer, FilterList } from "src/shared/modules/filterDrawer";
import { getDashboardDataProfileByMethod } from "src/shared/util/requestDataServer";
import { DrawerConfigProfile } from "./drawerConfigProfile";
import { ChartsList } from "./charts";
import { TableCustom } from "./table";
import { convertArrayOfObjectsToCSV } from "src/shared/util/functions";
import { ModalDiagnostic } from "./modalDiagnostic";
import OpacityIcon from '@mui/icons-material/Opacity';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import WaterTest from "./waterTest";
import SubSurfaceJobs from "./subSurfaceJob";
import CatChanges from "./catChanges";

export interface IModalAnalystProps {
  activeCart: any,
  close: () => void
}

export interface ICharts {
  type: string,
  color: string,
  variableName: string,

}

const internalTabs = [
  { "name": "charts", "value": "charts", icon: <QueryStatsOutlinedIcon /> },
  { "name": "table", "value": "table", icon: undefined, svg: "/assets/icons/traficLight.svg" },
  { "name": "water", "value": "water", icon: <OpacityIcon /> },
  { "name": "taladro", "value": "taladro", icon: undefined, svg: "/assets/icons/rig.svg" },
  { "name": "cathistory", "value": "cathistory", icon: <ManageHistoryIcon /> },
  { "name": "production", "value": "production", icon: <OilBarrelIcon /> },
]

const filtersStatics: FilterList[] = [
  {
    name: 'Fecha Inicio',
    field: 'fromDate',
    type: 'date',
    action: 'equalAfter',
    buttons: [],
    options: []
  },
  {
    name: 'Fecha Fin',
    field: 'toDate',
    type: 'date',
    action: 'equalBefore',
    buttons: [],
    options: []
  }
]

export const ModalAnalyst = ({ activeCart, close }: IModalAnalystProps) => {

  const { locationName, method, locationSetPoints, fieldActivities } = useSelector((state) => state.location);

  const [listOfProfiles, setlistOfProfiles] = useState<any[]>([])

  const [loading, setloading] = useState(false)

  const [mergedActiveProfile, setmergedActiveProfile] = useState<any>(undefined)

  const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)

  const [activeProfile, setActiveProfile] = useState<any>(undefined)

  const [showFilters, setshowFilters] = useState(false)

  const [profileDrawer, setProfileDrawer] = useState(false)

  const [filteredData, setFilteredData] = useState<Filter[]>([]);

  const [filters, setFilters] = useState<FilterList[]>(filtersStatics)

  const [dataToTable, setdataToTable] = useState<any[]>([])

  const [waterDataTable, setWaterDataTable] = useState<any[]>([])

  const [subSubfaceDataTable, setSubSurfaceDataTable] = useState<any[]>([])

  const [catChanges, setCatChanges] = useState<any[]>([])

  const [modalDiagnostic, setModalDiagnostic] = useState(false)


  useEffect(() => {
    setloading(true);
    getDashboardDataProfileByMethod(method)
      .then((data) => {
        const list: any[] = []
        for (const report of data) {
          list.push(report?.jsonConfig)
        }
        setlistOfProfiles(list);
      }).finally(() => {
        setloading(false);
      })
  }, [activeCart])

  useEffect(() => {
    const mergedConfig = activeProfile?.config?.map((variable: any) => {
      const existSetPointMin = locationSetPoints?.find((setpoint: any) => setpoint.id === variable.variableId && setpoint.limit === "Down");
      const existSetPointAverage = locationSetPoints?.find((setpoint: any) => setpoint.id === variable.variableId && setpoint.limit === "Average");
      const existSetPointMax = locationSetPoints?.find((setpoint: any) => setpoint.id === variable.variableId && setpoint.limit === "Up");

      return {
        ...variable,
        min: existSetPointMin ? parseFloat(existSetPointMin.value) : variable.min,
        average: existSetPointAverage ? parseFloat(existSetPointAverage.value) : variable.average,
        max: existSetPointMax ? parseFloat(existSetPointMax.value) : variable.max,
      }
    })

    setmergedActiveProfile({ ...activeProfile, config: mergedConfig })
  }, [activeProfile, locationSetPoints])


  const onClickChangeSummaryView = (tabId: string) => {
    setactiveSummaryView(tabId)
  }

  const handleSelectOptionFilter = (filter: Filter) => {
    const extraFilter = filteredData.filter(f => f.name !== filter.name);
    setFilteredData([...extraFilter, filter]);
  };

  const handleResetSearch = () => {
    setFilteredData([]);
    // setData(locations||[]);
  };

  const handleOnChangeProfileConfig = (variableId: string, key: string, value: any) => {
    // console.log({ variableId, key, value, mergedActiveProfile })
    const findIndex = mergedActiveProfile?.config?.findIndex((p: any) => p.variableId === variableId);
    if (findIndex !== -1) {
      let newConfig = mergedActiveProfile?.config

      if (key === "variable") {
        const findVariable = mergedActiveProfile?.variables?.find((p: any) => p.variableId === value);
        if (findVariable) {
          const hasBeenConfiguredBefore = mergedActiveProfile?.config?.find((c: any) => c.variableId === value)
          console.log({ mergedActiveProfile, variableId, key, value, hasBeenConfiguredBefore })
          if (!hasBeenConfiguredBefore) {
            newConfig[findIndex].variableId = findVariable.variableId
            newConfig[findIndex].variableName = findVariable.name
          }
        }
      } else {
        newConfig[findIndex][key] = value
      }

      setmergedActiveProfile({ ...mergedActiveProfile, config: newConfig })
    }
  }

  const handleDownloadCSV = () => {
    try {
      if (dataToTable?.length > 0) {
        const csv = convertArrayOfObjectsToCSV(
          dataToTable
        );
        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", "report.csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (error) {
      console.log({ error });
    } finally {
    }
  };

  return (
    <Box className="modal-container ">
      {/* header */}
      <Grid className="modal-header" >
        <Grid className="logo-image">
          <Box
            component="img"
            src="/assets/icons/logo_without_text_white_effect.svg"
            alt="logo"
            sx={{
              width: { xs: 60, md: 70, },
              height: { xs: 70, md: 70 },
            }}
          />
          <Box
            component="img"
            src="/assets/icons/logo_text_white.svg"
            alt="logo"
            sx={{
              width: { xs: 0, md: 150, },
              height: { xs: 0, md: 70 },
            }}
          />
        </Grid>
        <Grid className="textwellname">
          {locationName}
        </Grid>
        <Grid className="button-header">
          <IconButton
            size="small"
            color="error"
            sx={{
              backgroundColor: '#fff',
              width: '30px',
              height: '30px',
              '&:hover': {
                backgroundColor: '#fff',
                color: '#000'
              }
            }}
            onClick={() => close()}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid>

        </Grid>
      </Grid>
      {/* body */}
      <Grid className="modal-body" >
        {/* button line 1 */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, ml: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 1 }}>
            {
              internalTabs.map((item, index) => {
                return (
                  <IconButton
                    onClick={() => onClickChangeSummaryView(item.value)}
                    key={index}
                    sx={{
                      backgroundColor: activeSummaryView === item.value ? "#1976d2" : "#f0f0f0",
                      color: activeSummaryView === item.value ? "#fff" : "#000",
                      "&:hover": {
                        backgroundColor: activeSummaryView === item.value ? "#42a5f5" : "#f0f0f0",
                      },
                    }}
                  >
                    {item.icon ? item.icon : <img src={item.svg} alt="icon" width={25} height={25} />}
                  </IconButton>
                )
              })
            }
          </Box>
        </Box>
        {/* button line 2 */}
        <Box sx={{ display: "flex", justifyContent: "space-between", m: 3, gap: 1 }}>
          <Grid size={3} className="dropdown-componenet">
            <AssessmentOutlinedIcon sx={{ width: 30, height: 30, color: 'rgba(164, 161, 161, 0.601)' }} />
            <Autocomplete
              fullWidth
              disablePortal
              size="small"
              value={activeProfile?.name || null}
              options={listOfProfiles?.map((profile) => ({ id: profile.id, label: profile.name }))}
              onChange={(event: any, newValue: any) => setActiveProfile(listOfProfiles.find((profile) => profile.id === newValue?.id))}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Perfil"
                  fullWidth
                />
              )}
            />
            {activeProfile && (
              <IconButton
                size="small"
                color="primary"
                onClick={() => setProfileDrawer(true)}
              >
                <SettingsIcon />
              </IconButton>
            )}
          </Grid>
          <Grid>
            {activeSummaryView === "table" && (
              <IconButton
                size="small"
                color="primary"
                onClick={() => handleDownloadCSV()}
              >
                <FileDownloadIcon />
              </IconButton>
            )}
            <IconButton
              size="small"
              color="primary"
              onClick={() => setshowFilters(true)}
            >
              <FilterAltIcon />
            </IconButton>
          </Grid>
        </Box>
        <ModalDiagnostic
          open={modalDiagnostic}
          onClose={() => setModalDiagnostic(false)}
        />
        {/* FilterDrawer */}
        <FilterDrawer
          showFilters={showFilters}
          filters={filters}
          filteredData={filteredData}
          setshowFilters={setshowFilters}
          handleSelectOptionFilter={handleSelectOptionFilter}
          resetFilters={handleResetSearch}
        />
        <DrawerConfigProfile
          open={profileDrawer}
          setOpen={setProfileDrawer}
          profile={mergedActiveProfile}
          onchangeProfileConfig={handleOnChangeProfileConfig}
        />
        {activeSummaryView === "charts" && (
          <ChartsList
            mergedActiveProfile={mergedActiveProfile}
            filteredData={filteredData}
            filters={filters}
          />
        )}

        {activeSummaryView === "table" && (
          <TableCustom
            mergedActiveProfile={mergedActiveProfile}
            dataToTable={dataToTable}
            setdataToTable={setdataToTable}
            filteredData={filteredData}
            filters={filters}
          />
        )}
        {activeSummaryView === "water" && (
          <WaterTest
            dataToTable={waterDataTable}
            setdataToTable={setWaterDataTable}
            filteredData={filteredData}
            filters={filters}
          />
        )}

        {activeSummaryView === "taladro" && (
          <SubSurfaceJobs
            dataToTable={subSubfaceDataTable}
            setdataToTable={setSubSurfaceDataTable}
            filteredData={filteredData}
            filters={filters}
          />
        )}

        {activeSummaryView === "cathistory" && (
          <CatChanges
            dataToTable={catChanges}
            setdataToTable={setCatChanges}
            filteredData={filteredData}
            filters={filters}
          />
        )}

      </Grid>
      {/* footer */}
      <Grid className="modal-footer" >
        <Badge badgeContent={0} color="warning">
          <Button
            variant="outlined"
            color="warning"
            size="small"
            sx={{ width: '95px', fontSize: '11px', fontWeight: 'bold' }}
            onClick={() => { }}
            startIcon={<FmdBadIcon />}
          >
            Alertas
          </Button>
        </Badge>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ width: '95px', fontSize: '11px', fontWeight: 'bold' }}
          onClick={() => setModalDiagnostic(true)}
        >
          Diagnosticar
        </Button>
      </Grid>
    </Box>
  )
}
